import './ccf-avatar.module.scss';
import { Theme, Avatar } from '@mui/material';
import { withStyles } from '@mui/styles';


export interface CcfAvatarProps {
  width?: number;
  height?: number;
  fontSize?: number | string;
  color?: string;
  bgcolor?: string;
  border?: boolean;
  borderColor?: string;
  alt?:string;
  variant?: 'circular' | 'rounded' | 'square';
  children?:string;
  className?: string
}

/**
 * Component used to display Avatar styles
 * @param theme - Theme
 * @example <AvatarStyles />
 * @returns Avatar styles
 */
const AvatarStyles = (theme: Theme) => ({
  root: (props: CcfAvatarProps) => ({
    width: props.width,
    height: props.height,
    fontSize: props.fontSize,
    color: theme.palette?.text.primary,
    backgroundColor: props.bgcolor? props.bgcolor : theme.palette?.background.paper,
    border: props.border ? `1px solid ${props.borderColor}` : '0px',
    alt:props.alt,
    variant:props.variant,
    children:props.children,
  }),
});

export const CcfAvatar = withStyles(AvatarStyles, { name: 'ccf-avatar' })(
  ({ ...props }: CcfAvatarProps) => <Avatar {...props} />);
